export const EARLY_RENEWAL_COMPONENT_NAME = 'hotpay-early-renewal'

export const EARLY_RENEWAL_STEPS = {
  PRODUCT_OFFER: 'PRODUCT_OFFER',
  PROPOSAL: 'PROPOSAL'
}

export const SubscriptionPeriodicty = Object.freeze({
  'WEEKLY': 'WEEKLY',
  'MONTHLY': 'MONTHLY',
  'BIMONTHLY': 'BIMONTHLY',
  'QUARTERLY': 'QUARTERLY',
  'BIANNUAL': 'BIANNUAL',
  'ANNUAL': 'ANNUAL'
})

export const SUBSCRIPTION_PERIOD_LABELS = {
  'WEEKLY': 'builder.sidebar.forms.earlyRenewal.week',
  'MONTHLY': 'builder.sidebar.forms.earlyRenewal.month',
  'BIMONTHLY': 'builder.sidebar.forms.earlyRenewal.bimester',
  'QUARTERLY': 'builder.sidebar.forms.earlyRenewal.quarter',
  'BIANNUAL': 'builder.sidebar.forms.earlyRenewal.biannual',
  'ANNUAL': 'builder.sidebar.forms.earlyRenewal.year'
}

export const SUBSCRIPTION_PERIODICITY_LABELS = {
  'WEEKLY': 'builder.sidebar.forms.earlyRenewal.weekly',
  'MONTHLY': 'builder.sidebar.forms.earlyRenewal.monthly',
  'BIMONTHLY': 'builder.sidebar.forms.earlyRenewal.bimonthly',
  'QUARTERLY': 'builder.sidebar.forms.earlyRenewal.quarterly',
  'BIANNUAL': 'builder.sidebar.forms.earlyRenewal.semester',
  'ANNUAL': 'builder.sidebar.forms.earlyRenewal.yearly'
}
